<template>
    <div class="page bg-gray page-flex">
        <backTitleBar></backTitleBar>
        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div v-for="(item,$index) in data" :key="$index" class="list-item click" @click="getScrollerPosition();$router.push({ name:'disStockCabinetDetail',query:{shopId:item.shopId}})">
                    <div class="flex-center">
                        <div class="flex1 fs-32 color-333 flex-center"><div class="label">{{equipment_type[item.equipmentType]}}</div>{{item.shopName}} </div>

                        <div class="fs-32 color-org ml-20">待补货</div>
                    </div>
                    <div class="flex fs-28 mt-10">
                        <div class="color-999">数量：
                            <span class="color-333">{{item.lackNum + item.weighLackNum}}</span>
                        </div>
                        <div class="color-999 ml-50" v-if="item.equipmentType == 'weigh'">重量：
                            <span class="color-333">{{item.weighLackWeight/1000}}kg</span>
                        </div>
                        <div class="color-999 ml-50" >种类：
                            <span class="color-333">{{item.lackItemCount + item.weighLackItemCount + item.weighLackWeightCount}}</span>
                        </div>
                    </div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "disStockCabinet",
        mixins: [initData,routerBack],
        components:{backTitleBar},
        data(){
            return{
                equipment_type: {
                    spring: '弹簧柜',
                    rfid: 'RFID柜',
                    consign: '格子柜',
                    weigh: '称重柜'
                }
            }
        },
        methods:{
            beforeInit() {
                this.params = { page : this.page, limit: this.limit};
                this.url = 'item/shopItem/qryLackShopPageList';
                return true
            },
        },
        beforeRouteEnter(to, from, next) {
            if(from.name == "disStockCabinetDetail") {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack) {
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .list-item{
        margin: .2rem .24rem;
        background: #fff;
        border-radius: .12rem;
        overflow: hidden;
        padding: .2rem .24rem .2rem .34rem;
        border-left: .06rem solid $org;
        .label{
            padding: 0 .1rem;
            height: .4rem;
            line-height: .4rem;
            margin-right: .1rem;
            background: $main-color;
            color: #fff;
            font-size: .24rem;
            font-weight: normal;
            border-radius: .06rem;
        }
    }
</style>



// WEBPACK FOOTER //
// disStockCabinet.vue?5176e676